import {useInfiniteQuery} from 'react-query';
import {getBuyers} from 'services/buyers';

const UseGetBuyers = (app: string, sortFilter: string, newSearch: string) => {
  const {
    data: buyers,
    isLoading: isBuyersLoading,
    fetchNextPage,
  } = useInfiniteQuery(
    ['getBuyers', sortFilter, newSearch],
    ({pageParam = 1, queryKey}) =>
      getBuyers(queryKey[1], pageParam, newSearch, app),
    {
      getNextPageParam: (lastPage, allPages) => {
        return allPages[allPages.length - 1].next
          ? new URL(allPages[allPages.length - 1]?.next || '').searchParams.get(
              'page',
            )
          : undefined;
      },
    },
  );
  return {
    buyers,
    isBuyersLoading,
    fetchNextPage,
  };
};

export default UseGetBuyers;
